// Central place for backend/frontend base URLs.
//
// To run against a local backend, change API_BASE_URL below (and switch it
// back before deploying to production).
//
// IMPORTANT: these are *origins* only (no trailing slash, no /api suffix),
// because the call sites already include the path prefix, e.g.
//   `${API_BASE_URL}/api/profile/`, `${API_BASE_URL}/skilog/logs/`, etc.
// For a local Django dev server use: http://127.0.0.1:8000

export const API_BASE_URL = 'https://api.6buoys.com';
export const WEB_BASE_URL = 'https://6buoys.com';
